import ApiCore from "../utilities/core";

const url = 'roles';
const plural = 'roles';
const single = 'role';

export const apiRoles = new ApiCore({
    getAll: true,
    getSingle: true,
    post: true,
    put: true,
    patch: true,
    delete: true,
    url: url,
    plural: plural,
    single: single,
    requireToken: true
});

